import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { EstimateContainer } from '../../common/components/redesignComponents/common/Redesign.styles';
import ErrorComponent from '../../common/components/ErrorComponent';
import { confirmAlert, generalAlertError } from '../../common/utils/alerts';
import {
  addRcFamigliaQuoteToCart, rcFamigliaQuotesGetQuotes, removeRcFamigliaQuoteFromCart,
} from '../../features/insuranceRequests/insuranceRequestsActions';
import PageLoading from '../../common/componentsV2/elements/PageLoading';
import { RcFamigliaQuotesStyles, RiskContainer } from './styles/RcFamigliaResultPage.styles';
import RcFamigliaModal from './components/RcFamigliaModal';
import RcFamigliaModalButtons from './components/RcFamigliaModalButtons';
import ConversationModal from '../../common/components/redesignComponents/Modal/ConversationModal';
import { primaQuoteTypes } from '../../common/constants';
import { V2FontImport } from '../../common/formInputsV2/V2Fonts';
import ResultOverviewRow from '../../common/components/redesignComponents/ResultPageComponents/v2/ResultOverviewRow';
import RcFamigliaSummaryCard from '../../common/components/redesignComponents/ResultPageComponents/v2/RcFamigliaSummaryCard';
import QuoteCostSummaryCard from '../../common/components/redesignComponents/ResultPageComponents/v2/QuoteCostSummaryCard';
import {
  OutlineActionButton,
  ActionButtonBadge,
} from '../../common/components/redesignComponents/ResultPageComponents/v2/SecondaryActionButtons.styles';
import { ChatIcon } from '../../common/components/redesignComponents/ResultPageComponents/v2/ActionIcons';

function RcFamigliaResultPage() {
  const { requestToken } = useParams();
  const navigate = useNavigate();
  const {
    loading,
    error,
    insuranceRequest,
    customer,
    quotations,
    addingQuote,
    processingQuote,
    riskQuotations,
    // toSelect,
    quote_id_to_add,
    thread,
    est_provvigioni,
  } = useSelector((store) => store.insuranceRequests.rc_famiglia);
  const [showConversationModal, setShowConversationModal] = useState(false);
  const { quoteTypes } = useSelector((store) => store.utilities.quoteTypes);

  // const [showModal, setShowModal] = useState(false);
  const refresh = () => rcFamigliaQuotesGetQuotes(requestToken);
  const silentRefresh = () => rcFamigliaQuotesGetQuotes(requestToken);

  const modifyData = () => {
    navigate('/quote/rc-famiglia', {
      state: { requestToken },
    });
  };

  const selectQuotation = (quoteId, closeButton) => {
    confirmAlert('Sei Sicuro di aggiungere questa quotazione?', () => addRcFamigliaQuoteToCart(
      quoteId,
      refresh,
      modifyData,
      closeButton,
      quote_id_to_add,
    ));
  };

  const removeItemFromCart = (quoteId) => {
    confirmAlert('Sei Sicuro di rimuovere questa quotazione?', () => removeRcFamigliaQuoteFromCart(quoteId, refresh, modifyData));
  };

  useEffect(() => {
    rcFamigliaQuotesGetQuotes(requestToken);
  }, [requestToken]);

  const handleRequestPurchase = () => {
    if (processingQuote === null) {
      generalAlertError('Seleziona Prima La Responsabilita Civile', 'Errore');
      return;
    }

    navigate(`/quotes/rc-famiglia/purchase/${requestToken}`);
  };

  const getTotal = () => {
    let quoteInProccessAmount = 0;
    let risksTotalAmount = 0;

    if (processingQuote !== null && processingQuote.amount !== null) {
      quoteInProccessAmount = parseFloat(processingQuote.amount);
    }

    const riskTypes = quoteTypes.filter((t) => t.id !== 'res_civile');

    for (let x = 0; x < riskTypes.length; x++) {
      const type = riskTypes[x];
      if (riskQuotations && riskQuotations[type.id] !== undefined) {
        for (let i = 0; i < riskQuotations[type.id].length; i++) {
          const item = riskQuotations[type.id][i];

          risksTotalAmount += parseFloat(item.amount);
        }
      }
    }

    return (quoteInProccessAmount + risksTotalAmount).toFixed(2);
  };

  if (loading) {
    return <PageLoading />;
  }

  if (error !== null) {
    return <ErrorComponent error={error} />;
  }

  return (
    <>
      {showConversationModal && (
        <ConversationModal
          requestId={insuranceRequest?.id}
          threadId={thread?.thread_id}
          onClose={() => {
            setShowConversationModal(false);
            silentRefresh();
          }}
          onUpdated={() => silentRefresh()}
          location="quotation_rc_famiglia_result"
        />
      )}
      <V2FontImport />
      <RcFamigliaQuotesStyles>
        <div className="resultsPage">
          <ResultOverviewRow>
            <RcFamigliaSummaryCard
              customer={customer}
              insuranceRequest={insuranceRequest}
              modifyData={modifyData}
            />
            <QuoteCostSummaryCard
              processingQuote={processingQuote}
              quoteTypes={quoteTypes}
              riskQuotations={riskQuotations}
              primaQuoteTypes={primaQuoteTypes}
              getTotal={getTotal}
              onProcedi={() => handleRequestPurchase()}
              rcTypeLabel={processingQuote?.product_name}
              est_provvigioni={est_provvigioni}
            />
          </ResultOverviewRow>
          <div className="row">
            <div className="col-12 ">
              <EstimateContainer>
                <div className="d-flex gap-2 justify-content-end ">
                  <div>
                    {/* {localStorage.getItem('quoteNewResult') === 'done' && (
                      <div style={{ cursor: 'pointer' }} onClick={() => firePurchaseTour()}>
                        <button className="btn btn-success px-2 py-1">Tutorial</button>
                      </div>
                    )} */}
                    <OutlineActionButton
                      type="button"
                      onClick={() => {
                        setShowConversationModal(true);
                        if (thread?.unreadMessages > 0) silentRefresh();
                      }}
                    >
                      <ChatIcon />
                      Contatta il Backoffice
                      {thread?.unreadMessages > 0 && (
                        <ActionButtonBadge>
                          {thread.unreadMessages}
                          <span className="visually-hidden">messaggi non letti</span>
                        </ActionButtonBadge>
                      )}
                    </OutlineActionButton>
                  </div>
                </div>
              </EstimateContainer>
            </div>
          </div>
          {quotations && !quotations.res_civile
            && (
              <div className="alert alert-info mx-2" role="alert">
                <h4 className="alert-heading">Avviso!</h4>
                <p className="m-0">Il preventivo non è riuscito per problemi relativi ai dati assicurativi. Si prega di contattare il nostro backoffice per ottenere il preventivo o ulteriori informazioni.</p>
              </div>
            )}

          {quotations && quotations.res_civile
            && (
              <>
                <RiskContainer className="mb-3 pb-3 result-home-third-step">
                  {quoteTypes.map((type, index) => (
                    <React.Fragment key={index}>
                      {quotations && quotations[type.id] && (
                        <RcFamigliaModalButtons
                          insuranceRequest={insuranceRequest}
                          processingQuote={processingQuote}
                          type={type}
                          removeItemFromCart={removeItemFromCart}
                          riskQuotations={riskQuotations}
                        />
                      )}
                    </React.Fragment>
                  ))}
                </RiskContainer>
                {quoteTypes.map((type, index) => (
                  <RcFamigliaModal
                    insuranceRequest={insuranceRequest}
                    type={type}
                    key={index}
                    addingQuote={addingQuote}
                    quotations={quotations}
                    selectQuotation={selectQuotation}
                    processingQuote={processingQuote}
                  />
                ))}
              </>
            )}
        </div>

      </RcFamigliaQuotesStyles>
    </>
  );
}

export default RcFamigliaResultPage;
